import React, { useState } from 'react'
import { Panel, Row, Col, Input, SelectPicker } from 'rsuite'
import SearchButton from '../../../components/buttons/searchButton/SearchButton'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'
import DatePickerCustom from '../../../components/datePicker/DatePickerCustom'
import moment from 'moment'
import { REQUEST_DATE_FORMAT } from '../../../constants/date'

export default function ListOfAssetsFormSearch({ schema, loading, onSearch = () => {}, ...props }) {
  const [assetCode, setAssetCode] = useState()
  const [assetName, setAssetName] = useState()
  const [assetType, setAssetType] = useState()

  return (
    <>
      <Panel header={'ค้นหา'} bordered collapsible defaultExpanded>
        <Row style={{ marginTop: -10 }}>
          <Col lg={4} md={4} sm={24} xs={24}></Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            {schema.assetCode.label}
            <Input
              placeholder={schema.assetCode.hint || schema.assetCode.label}
              value={assetCode}
              onChange={(value) => {
                setAssetCode(value)
              }}
            />
          </Col>

          <Col lg={8} md={8} sm={24} xs={24}>
            {schema.assetName.label}
            <Input
              placeholder={schema.assetName.hint || schema.assetName.label}
              value={assetName}
              onChange={(value) => {
                setAssetName(value)
              }}
            />
          </Col>
          <Col lg={4} md={4} sm={24} xs={24}></Col>
        </Row>

        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24}></Col>

          <Col lg={8} md={8} sm={24} xs={24}>
            {schema.assetType.label}
            <SelectPicker
              searchable={false}
              data={schema.assetType.options}
              value={assetType}
              block
              placeholder={`เลือก${schema.assetType.label || ''}`}
              onChange={(value) => {
                setAssetType(value)
              }}
            />
          </Col>
        </Row>

        <Row style={{ marginTop: 20 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}></Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <SearchButton
              disabled={loading}
              onClick={() => {
                let request = {
                  assetName: assetName,
                  assetCode: assetCode,
                  assetType: assetType,
                }
                onSearch(request)
              }}
              style={{ marginTop: 0, marginLeft: 0 }}
            >
              ค้นหา
            </SearchButton>
            <CancelButton
              onClick={() => {
                setAssetName('')
                setAssetCode('')
                setAssetType('')
                onSearch({})
              }}
              style={{ marginTop: 0, marginLeft: 10 }}
            >
              ยกเลิก
            </CancelButton>
          </Col>
        </Row>
      </Panel>
    </>
  )
}
